import { FC } from 'react';
import { useFm } from '@web3/base-hooks';
import { Block } from '@/components/block';
import Table from './table';
import { Link } from './link';
import styles from './index.module.scss';

export const Swap: FC = () => {
  const fm = useFm();

  return (
    <Block clsName={styles.swapWrapper} noHeader>
      <div className={styles.swap}>
        <div className={styles.left}>
          <div className={styles.title}>{fm('bestTradingRoute')}</div>
          <div className={styles.strong}>{fm('tenKPlusTokens')}</div>
          <div className={styles.strong}>{fm('plusTwentyChains')}</div>
          <div className={styles.desc}>{fm('coverChainsAndTokens')}</div>
          <Link />
        </div>
        <div className={styles.right}>
          <Table />
        </div>
      </div>
    </Block>
  );
};

export default Swap;
